<template>
  <h3>注册页</h3>
</template>

<script>
export default {
  name: "Register"
}
</script>

<style scoped>

</style>